import { Stack, Box, Button, TextField, Grid, Skeleton } from '@mui/material'
import {useState, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import { updateProfileCompany } from '../reducers/profilesReducers';
import Select from 'react-select' 
import SnackBarAlert from '../../../../components/SnackBarAlert';
import { updateProfileSnackBar } from '../profileSlice';
import StarRequired from '../../../../components/StarRequired';
import TextAreaEditor from '../../products/components/TextAreaEditor';
import { checkValidation } from '../../../../utilities/userFeaturesValidation';
import StoreSchedule from './StoreSchedule';

const Profile : React.FC<any> = ({ profile }) => {

    const dispatch = useDispatch()
    const { category, loading_category } = useSelector((state : RootState) => state.step_state)
    const { update_profile, loading_update_profile } = useSelector((state : RootState) => state.profile)

    const [companyForm, setCompanyForm] = useState<any>({
        name : "",
        legalName : "",
    });
    
    const [loaded, setLoaded] = useState(true);
    const [valueDescription, setValueDescription] = useState("");
    const [errorDescription, setErrorDescription] = useState(false);

    const [operationalTime, setOperationalTime] = useState<any>([]);
    const [defaultOperation, setDefaultOperation] = useState<any>([]);

    const onChangeFormValue = (e : any) => {
        const { name, value } = e.target 
        setCompanyForm({...companyForm, [name] : value })
    }

    const [selectedCategoryCompany, setSelectedCategoryCompany] = useState<any>([]);
    const [errorCategoryCompany, setErrorCategoryCompany] = useState<boolean>(false);

    const optionsIsPKP  = [
        { value : false, label : "Perusahaan Non PKP"},
        { value : true, label : "Perusahaan PKP"}
    ]
    const [selectedIsPKP, setSelectedIsPKP] = useState<any>([]);
    const [errorIsPKP, setErrorIsPKP] = useState<boolean>(false);


    const handleChangeCategoryCompany = (value: any) : void => {
        setErrorCategoryCompany(false)
        setSelectedCategoryCompany(value)
    }

    const handleChangeIsPKP = (value: any) : void => {
        setErrorIsPKP(false)
        setSelectedIsPKP(value)
    }

    useEffect(() => {
        if(profile) {
            setCompanyForm({...companyForm,
                legalName : profile.legalName,
                name : profile.name
            })
            setValueDescription(profile.description || "")
            setLoaded(true)
            setSelectedIsPKP({value : profile.isPKP, label : profile.isPKP ? "Perusahaan PKP" : "Perusahaan Non PKP"})
            setSelectedCategoryCompany({value : profile.category._id, label : profile.category.name})
            setDefaultOperation(profile.operationTime || [])
        }
        // eslint-disable-next-line
    }, [profile]);

    const onClickSave = () => {
        const body = {
            id : profile._id,
            data : {
                "name": companyForm.name,
                "legalName": companyForm.legalName,
                "isPKP": selectedIsPKP.value,
                "category": selectedCategoryCompany.value,
                "type": profile.type._id,
                "owner": profile.owner,
                "platform": profile.platform,
                "logo": profile.logo || "https://mpindo.sgp1.digitaloceanspaces.com/vendor/47adfa24-cc5d-4966-a075-f95108191c50no-photo.png",
                "banner": profile.banner,
                "description" : valueDescription,
                "operationTime" : operationalTime.filter((item:any) => item.active).map((item:any) => ({ 
                    day : item.day, open: item.open, close: item.close, ...item
                }))
            }
        }
        dispatch(updateProfileCompany(body))
    }

    useEffect(() => {
        if(update_profile) {
            setTimeout(() => {
                dispatch(updateProfileSnackBar())
            }, 3000);
        }
        // eslint-disable-next-line
    }, [update_profile]);

    return (
        <Stack sx={{ width: '100%' }}>
            <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} xs={12}>
                    <Box><h4>Legal Name <StarRequired/></h4></Box>
                    <TextField
                        margin="dense"
                        fullWidth
                        id="legalName"
                        name="legalName"
                        size="small"
                        placeholder='PT Pasar Pemesanan Indonesia'
                        value={companyForm.legalName}
                        onChange={onChangeFormValue}
                        disabled
                        required
                    />
                </Grid>
                <Grid item xl={6} lg={6} md={6} xs={12}>
                    <Box><h4>Business Name <StarRequired/></h4></Box>
                    <TextField
                        margin="dense"
                        fullWidth
                        id="name"
                        placeholder='Pasar Pemesanan'
                        value={companyForm.name}
                        name="name"
                        size="small"
                        onChange={onChangeFormValue}
                        disabled
                        required
                    />
                </Grid>
                <Grid item xl={6} lg={6} md={6} xs={12}>
                    <Box pt={1}><h4>Category Company <StarRequired/></h4></Box>
                    <Box pt={1}>
                        { loading_category ? 
                        <Box mt={0} pt={0}><Skeleton height={60} /></Box>
                        :
                        <Select
                            placeholder="Select Category Company"
                            value={selectedCategoryCompany}
                            isSearchable={true}
                            options={category && category}
                            onChange={handleChangeCategoryCompany}
                            id="select-style-cat"
                        /> }
                    </Box>
                    { errorCategoryCompany ? <div className="error-p"><p>Category is required</p></div> : null }
                </Grid>
                <Grid item xl={6} lg={6} md={6} xs={12}>
                    <Box pt={1}><h4>Taxable Type <StarRequired/></h4></Box>
                    <Box pt={1}>
                        <Select
                            placeholder="Select Taxable "
                            value={selectedIsPKP}
                            isSearchable={true}
                            options={optionsIsPKP && optionsIsPKP}
                            onChange={handleChangeIsPKP}
                            id="select-style-type"
                        />
                    </Box>
                    { errorIsPKP ? <div className="error-p"><p>Taxable Type is required</p></div> : null }
                </Grid>
                <Grid item xl={12} lg={12} md={12} xs={12}>
                <StoreSchedule
                    operationalTime={operationalTime}
                    setOperationalTime={setOperationalTime}
                    defaultValue={defaultOperation}
                />
                </Grid>
                <Grid item xl={12} lg={12} md={12} xs={12}>
                    <Box py={1}>
                        <Box py={1}><h4>About Company</h4></Box>
                        <TextAreaEditor 
                            value={loaded && valueDescription}
                            setValue={setValueDescription}
                            error={errorDescription}
                            setError={setErrorDescription}
                            placeholder="Please write about your company"
                            loaded={loaded}
                        />
                    </Box>
                </Grid>
            </Grid>


            { checkValidation('UPDDETCOM790347') &&
            <Stack sx={{my:3}} flexDirection="row" justifyContent="flex-end">
                <Button 
                    variant='contained'
                    onClick={onClickSave}
                    disabled={loading_update_profile}
                >{loading_update_profile ? "Loading.." : "Save"}</Button>
            </Stack> }
            <SnackBarAlert message={`Success update Profile Company.`} initialState={update_profile} />
        </Stack>
    )
}
 
export default Profile
